import React, { useState } from "react";
import { Link } from "react-router-dom";

const Login = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      const response = await fetch(
        `https://api.kero.zone/dogking/login?name=${username}&psw=${password}`
      );
      const data = await response.json();

      if (data.uid && data.uid !== "0") {
        onLoginSuccess &&
          onLoginSuccess(data.uid, { username, password }); // Notify parent component with credentials
      } else {
        setError("用户名或密码错误");
      }
    } catch (error) {
      setError("网络错误,稍等重试或者联络管理员");
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-r from-blue-500 to-indigo-600">
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-sm">
        <h2 className="text-center text-2xl font-bold mb-4 text-gray-800">
          报分用户登录
        </h2>
        <form>
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block text-gray-700 font-medium"
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:ring-indigo-300"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="password"
              className="block text-gray-700 font-medium"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:ring-indigo-300"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {error && <p className="text-red-500 text-sm mb-3">{error}</p>}
          <button
            type="button"
            className="w-full bg-indigo-500 text-white py-2 rounded hover:bg-indigo-600 transition duration-200"
            onClick={handleLogin}
          >
            Login
          </button>
          <Link to="/register">
            <button
              type="button"
              className="w-full bg-gray-500 text-white py-2 rounded mt-3 hover:bg-gray-600 transition duration-200"
            >
              注册新用户
            </button>
          </Link>
        </form>
      </div>
    </div>
  );
};

export default Login;
